const estatusSiniestro = [
  {
    label: "Opción 1",
    value: "value1",
  },
  {
    label: "Opción 2",
    value: "value2",
  },
];

const experto = [
  {
    label: "Opción 1",
    value: "value1",
  },
  {
    label: "Opción 2",
    value: "value2",
  },
];

const ajustador = [
  {
    label: "Opción 1",
    value: "value1",
  },
  {
    label: "Opción 2",
    value: "value2",
  },
];

const movimientos = [
  {
    id: 1,
    tipo: "Recuperaciones",
    fecha: "00/00/0000",
    monto: "0.00",
    moneda: "USD",
    estado: "pagado",
  },
  {
    id: 2,
    tipo: "Tipo",
    fecha: "00/00/0000",
    monto: "0.00",
    moneda: "USD",
    estado: "registrar",
  },
  {
    id: 3,
    tipo: "Recuperaciones",
    fecha: "00/00/0000",
    monto: "0.00",
    moneda: "USD",
    estado: "parcial",
  },
  {
    id: 4,
    tipo: "Tipo",
    fecha: "00/00/0000",
    monto: "0.00",
    moneda: "USD",
    estado: "pagado",
  },
  {
    id: 5,
    tipo: "Tipo",
    fecha: "00/00/0000",
    monto: "0.00",
    moneda: "USD",
    estado: "registrar",
  },
];

const totales = {
  reserva: "750000.00",
  pagoSiniestro: "0.00",
  pagoProveedores: "0.00",
  recuperacionMxn: "0.00",
  recuperacionUsd: "0.00",
};

const pagoMovimientos = [
  {
    id: 1,
    tipo: "Único",
    fecha: "00/00/0000",
    pagoRealizado: "0",
    deudaTotal: "0",
    tipoPago: "Tipo de pago",
    beneficiario: "Beneficiario",
    tipoBeneficiario: "Tipo de beneficiario",
    tipoCambio: "Tipo de cambio",
    metodoPago: "Transferencia",
    rfc: "RFC",
    cuenta: "Cuenta",
    clabe: "Clabe",
    banco: "Banco",
    iban: "IBAN",
    swift: "Swift Aba",
    cif: "CIF / NIF",
  },
];

export {
  estatusSiniestro,
  experto,
  ajustador,
  movimientos,
  totales,
  pagoMovimientos,
};
